<template lang="pug">
.case-container
  .case-content
    .case-case__title
        div(
          style="width:4px;height:80px;background-color: #478bca;"
        )
        .title__content
          span {{ $t('案例分享：虫虫拜拜') }}
          span {{ $t('专业上门除虫服务，健康家人，舒适生活。') }}
    .case-case__summary
      div(
        style="margin-right: 300px"
      )
        i.iconfont.iconhangye
        span {{ $t('广告主行业：家政服务') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('从供应商选择到数据展示的一站式解决方案。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('客户想尝试新渠道的媒体投放，但经过相关人员推荐的供应商后，发现价格没有很大优势，同时效果表现较为普通。产生了以下两点问题：') }}
        .content 1）{{ $t('苦于不知道该新渠道媒体的核心供应商是哪几家，价格政策在行业内是什么水平。') }}
        .content 2）{{ $t('担心如果替换供应商，相关账户充值、账户交接、运营数据分析、创意优化、合同协议等相关手续较为繁琐。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content 1）{{ $t('复歌独自开发“贵了么营销市场平台“全面整合了市场上现有的媒体渠道如”今日头条、快手、抖音等。同时集合了各个渠道的代理商以及供应商，较为全面的了解各个渠道的投放政策情况，可以最大限度的为广告主提供最优的采买价格。') }}
        .content 2）{{ $t('专业的运营团队，可以根据客户的需求以及目的建议以及采买相对应的投放渠道，同时也可收集投放数据，分析整合呈现给客户。在为客户减少与供应商的沟通成本同时，提高广告的优化效率。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户与复歌推荐的供应商保持了良好的合作关系，且持续投放中，投放相同渠道的媒体，为客户减少营销成本的同时提升整体的投放效率。') }}
  contact
</template>"
<script>
import Contact from '@/components/Contact'
export default {
  components: {
    Contact
  }
}
</script>
